import { render, staticRenderFns } from "./ReserveMobileFooter.vue?vue&type=template&id=37864fca"
import script from "./ReserveMobileFooter.vue?vue&type=script&lang=ts"
export * from "./ReserveMobileFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports